import PeopleIcon from "@mui/icons-material/People";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import StoreIcon from "@mui/icons-material/Store";
import WorkIcon from "@mui/icons-material/Work";
import { SxProps } from "@mui/material";
import { TFunction } from "i18next";

const singleTabStyle: SxProps = {
  textTransform: "none",
  color: "rgba(0,0,0,0.4)",
};

export const getTabsInfo = (t: TFunction) => [
  {
    label: t("searchPage.tabs.promotions"),
    icon: <PriceCheckIcon />,
    style: singleTabStyle}, {label: t("searchPage.tabs.stores"),
    icon: <StoreIcon />,
    style: { ...singleTabStyle, minWidth: "30%" },
  },
  {label: t("searchPage.tabs.services"), icon: <WorkIcon />, style: singleTabStyle},
  {label: t("searchPage.tabs.professionals"), icon: <PeopleIcon />, style: singleTabStyle},
];